import React from 'react';
import { Query } from 'react-apollo';
import Link from '@material-ui/core/Link';
import { GET_PERSONAL_STATEMENT_SUMMARY } from 'graphql/admin/essay-summary';

const PersonalStatements = ({ school }) => {
  if (!school) return 'Select a university';

  return (
    <Query
      fetchPolicy={'network-only'}
      query={GET_PERSONAL_STATEMENT_SUMMARY}
      variables={{
        schoolName: school.label,
      }}
    >
      {({ loading, error, data }) => {
        if (loading) return <p>Loading...</p>;
        if (error) return <p>Error :(</p>;

        return (
          <table width="100%">
            <thead>
              <tr>
                <td>Name</td>
                <td>Student name</td>
                <td>Status</td>
                <td>Documents</td>
              </tr>
            </thead>
            <tbody>
              {data.personal_statements.map((statement) => (
                <tr key={statement.id}>
                  <td>{statement.name}</td>
                  <td>{statement.user.name}</td>
                  <td>{statement.status}</td>
                  <td>
                    {statement.documents.map((document) => (
                      <Link
                        style={{ marginRight: '5px' }}
                        key={document.id}
                        href={document.document.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {document.document.filename}
                      </Link>
                    ))}
                    {statement.documents.length === 0 && 'No documents'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }}
    </Query>
  );
};

export default PersonalStatements;
